/**
 * Collapses the draft order summary's "Order Details" panel when the rep's
 * attention moves elsewhere — the page scrolls, or a click lands outside the
 * summary. The bar itself stays put; it's fixed and always visible.
 *
 * The panel is a CSS-only disclosure (a checkbox plus sibling selectors in
 * scss/objects/cart/_draft-order-cart-summary.scss), so collapsing it means
 * unchecking that input.
 */
const draftOrderCartSummary = () => {
  const container = document.querySelector(
    '.draft-order-cart-summary--container',
  );
  if (!container) return;

  // Queried on demand: the summary's inner markup is re-rendered on cart updates.
  const getInputsToggle = () =>
    container.querySelector('.draft-order-cart-summary-inputs-toggle');

  const collapse = () => {
    const inputsToggle = getInputsToggle();
    if (inputsToggle && inputsToggle.checked) inputsToggle.checked = false;
  };

  // Scroll and resize share a handler: either way the viewport moved out from
  // under the panel. Both also fire when the mobile keyboard opens, which the
  // focus check rules out.
  let ticking = false;
  const onViewportChange = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      // Focusing a field inside the panel scrolls/resizes the page on mobile to
      // make room for the keyboard. That's the browser moving, not the rep —
      // collapsing there would hide the field being typed into.
      if (!container.contains(document.activeElement)) collapse();
      ticking = false;
    });
  };

  // Bubble phase, so the panel's own labels (which are inside the container) get
  // to toggle the checkbox before this sees the click.
  const onDocumentClick = (event) => {
    if (container.contains(event.target)) return;
    collapse();
  };

  window.addEventListener('scroll', onViewportChange, { passive: true });
  window.addEventListener('resize', onViewportChange, { passive: true });
  document.addEventListener('click', onDocumentClick);
};

export default draftOrderCartSummary;
